module.exports = __webpack_public_path__ + "static/media/open_type_plugin.128a2008.png";